// The brochure is gated behind a lead capture form (see BrochureDownloadTrigger.ss):
// the modal's download link stays hidden until that form reports a completed
// submission, at which point it's revealed and clicked for the visitor.
//
// leadcapture:complete bubbles from the form body that sdots-lead-capture swaps
// the "thank you" content into, so listening on the document covers the form
// wherever modal.js has moved it to.
const brochureDownloadInit = () => {
    document.addEventListener('leadcapture:complete', (event) => {
        const gate = event.target.closest('[data-brochure-gate]')
        if (!gate) return

        const download = gate.querySelector('[data-brochure-download]')
        if (!download) return

        // event.target is the form body the "thank you" content was just swapped
        // into, so the download sits inside the form card rather than under it.
        event.target.appendChild(download)
        download.classList.remove('hidden')
        download.classList.add('flex')
        download.querySelector('a')?.click()
    })
}

brochureDownloadInit()
